module.exports = __webpack_public_path__ + "media/images/icons/flags/IO-4ba67ecb371da2ec892c5b84075b75b8.svg";